import {Injectable} from '@angular/core';
import Geometry from '@arcgis/core/geometry/Geometry';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {select, Store} from '@ngrx/store';
import {map, take, tap} from 'rxjs/operators';
import {AppState} from '../../../../../core/store/core.state';
import {MapService} from '../../../../../shared';

import {Dibujo, DibujoType, geometryTypeToDibujoType,} from '../../../../../chacra-core';

import {addDibujo, deleteDibujos} from './dibujos.actions';
import {selectAllDibujosByTipo} from './dibujos.selectors';


@Injectable()
export class DibujosEffects {
  addDibujo = createEffect(() =>
      this.actions$.pipe(
        ofType(addDibujo),
        map(action => action.dibujo),
        tap(async (dibujo: Dibujo) => {
            if (dibujo.dibujoTipo === DibujoType.POLYGON) {

              const allDibujos = await this.store.pipe(
                select(selectAllDibujosByTipo(DibujoType.POLYGON)),
                take(1))
                .toPromise()
              const dibujos = allDibujos.filter(d => d.dibujoId !== dibujo.dibujoId);

              const subtractor = this.mapCoreService.stringJsonToGeometry(dibujo.dibujoGeometria);

              for (let d of dibujos) {
                const inputGeometry = this.mapCoreService.stringJsonToGeometry(d.dibujoGeometria);
                const intersects = this.mapCoreService.intersects(subtractor, inputGeometry);
                if (intersects) {
                  let diffGeometry: Geometry;
                  const diffReturn = this.mapCoreService.difference(inputGeometry, subtractor);
                  if (diffReturn instanceof Geometry) {
                    diffGeometry = diffReturn;
                  } else {
                    diffGeometry = diffReturn[0];
                  }

                  this.store.dispatch(deleteDibujos({ids: [dibujo.dibujoId, d.dibujoId]}));

                  const intersectDibujo = {
                    dibujoId: this.mapCoreService.nextId(),
                    dibujoGeometria: JSON.stringify(diffGeometry.toJSON()),
                    dibujoTipo: geometryTypeToDibujoType(diffGeometry.type)
                  };

                  this.store.dispatch(addDibujo({dibujo: intersectDibujo}));

                  break;
                }
              }
            }
          }
        )
      ),
    {dispatch: false}
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private mapCoreService: MapService
  ) {
  }

}
